export const TAB_ISSUES = {
  ROOM_ISSUES: 'roomIssues',
  ASSET_ISSUES: 'assetIssues',
  AD_HOC_ISSUES: 'adHocIssues',
  MAINTENANCE_ISSUES: 'maintenanceIssues',
  ASSIGNMENTS: 'assignments'
} as const;

export const headerTabIssues = [
  { label: 'Location Issues', param: TAB_ISSUES.ROOM_ISSUES, value: 0 },
  { label: 'Asset Issues', param: TAB_ISSUES.ASSET_ISSUES, value: 1 },
  { label: 'Ad Hoc Issues', param: TAB_ISSUES.AD_HOC_ISSUES, value: 2 },
  { label: 'Maintenance Issues', param: TAB_ISSUES.MAINTENANCE_ISSUES, value: 3 },
  { label: 'Assignments', param: TAB_ISSUES.ASSIGNMENTS, value: 4 }
];
